import { FC } from 'react';

import { Background } from '@/components/Game/Steps/Background';
import type { IQuestion } from '@/types/question';
import type { IGame } from '@/types/game';

interface Step2Props {
  setStep: (value: number) => void;
  question: string;
  numberQuestion: number;
  questions: IQuestion[];
  idGame: number;
  setSelectedAnswer: (value: string[]) => void;
  scenarios: IGame[];
  points: number;
  responseStatus: { [x: number]: boolean | null };
}

const Step2: FC<Step2Props> = ({
  setStep,
  question,
  numberQuestion,
  questions,
  idGame,
  setSelectedAnswer,
  scenarios,
  points,
  responseStatus,
}) => (
  <Background
    setStep={setStep}
    page={11}
    message={question}
    button="Выбрать ответ"
    numberQuestion={numberQuestion}
    questions={questions}
    idGame={idGame}
    setSelectedAnswer={setSelectedAnswer}
    scenarios={scenarios}
    points={points}
    responseStatus={responseStatus}
  />
);

export default Step2;
